import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { CheckMarkIcon, ExclamationMarkOutlinedIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

type Props = {
  text: string
  completed?: boolean
  onclick: () => void
}

const EnrollmentProgressIncicator = ({ text, completed, onclick }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <div
        className={cn('h-5 w-5 rounded-full flex items-center justify-center ', {
          'bg-green-dark p-0.5': completed,
          'bg-red-light': !completed
        })}
      >
        {completed ? (
          <CheckMarkIcon color={tailwindColors.white.DEFAULT} />
        ) : (
          <ExclamationMarkOutlinedIcon color={tailwindColors.red.DEFAULT} />
        )}
      </div>
      <Typography.Link
        variant="label-medium"
        color={tailwindColors.grey.DEFAULT}
        onClick={onclick}
      >
        {text}
      </Typography.Link>
    </div>
  )
}

export default EnrollmentProgressIncicator
